import {useState,useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import './styles/app.css'
import './styles/responsive.css'
import MyRoutes from './routes/routes';

const App = () => {
  // const [role, setRole] =useState();


  // useEffect(()=>{
  //   const userString = sessionStorage.getItem("user");
  //   const value = JSON.parse(userString)
  //   setRole(value ? value.role : '')
  // },[])
  return (
<div >
< MyRoutes/>
</div>
  )
}

export default App